import { Box, Loader } from '@wix/design-system';
import { getSearchParams } from '@wix/package-picker-shared';
import { Checkout as PlatformCheckout } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
import { CreditExplanation } from './CheckoutCreditExplanation/CheckoutCreditExplanation';
import { CheckoutDisclaimer } from './CheckoutDisclaimer/CheckoutDisclaimer';
import { CheckoutTrustBuilder } from './CheckoutTrustBuilder/CheckoutTrustBuilder';
import { useCheckoutCallbacks } from './hooks';
export const Checkout = _ref => {
  let {
    shouldOpenDoublePurchaseModal
  } = _ref;
  const module = useCurrentModule();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const {
    siteGuid
  } = getSearchParams();
  const checkoutCallbacks = useCheckoutCallbacks({
    shouldOpenDoublePurchaseModal
  });
  const {
    didInitSuccess
  } = checkoutCallbacks;
  if (!selectedProductId || !selectedCycle || !siteGuid) {
    // TODO: Handle error
    return null;
  }
  const lineItem = {
    productId: selectedProductId,
    billingCycle: selectedCycle,
    quantity: 1,
    context: {
      msid: siteGuid
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    verticalAlign: "middle"
  }, !didInitSuccess && /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle",
    height: "500px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement(Box, {
    display: didInitSuccess ? 'block' : 'none',
    minHeight: "500px"
  }, /*#__PURE__*/React.createElement(PlatformCheckout.Root, {
    disclaimerRenderer: () => /*#__PURE__*/React.createElement(CheckoutDisclaimer, null),
    lineItems: [lineItem],
    checkoutProps: {
      appName: 'premium-purchase-plan',
      onBeforeSubmit: checkoutCallbacks.getShouldSubmit,
      onSubmitSuccess: checkoutCallbacks.handleSubmitSuccess,
      onInitSuccess: checkoutCallbacks.handleInitSuccess,
      onInitError: checkoutCallbacks.handleInitError,
      onSubmitError: checkoutCallbacks.handleSubmitError,
      summaryProps: {
        renderCustomFooter: () => /*#__PURE__*/React.createElement(CheckoutTrustBuilder, null),
        renderCreditExplanation: () => /*#__PURE__*/React.createElement(CreditExplanation, null)
      }
    }
  })));
};
//# sourceMappingURL=Checkout.js.map